import { render, staticRenderFns } from "./DNavigation.vue?vue&type=template&id=4fb05768&"
import script from "./DNavigation.vue?vue&type=script&lang=js&"
export * from "./DNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports